//
import Model from '@/models/Model'

/**
 * 
 */
export default class SlSellerSaleCommission extends Model {

  /**
   * 
   */
  resource() {
    return 'sl_seller_sale_commission'
  }
}